(() => {
    window.Dashboard = window.Dashboard || {};
    window.Dashboard.Models = window.Dashboard.Models || {};

    const REPORTIO_USER_ROLE = 1001;
    const REPORTIO_ADMIN_ROLE = 1032;

    class User {
        Id = undefined;
        UserName = undefined;
        FirstName = undefined;
        LastName = undefined;
        MobileNumber = undefined;
        Email = undefined;
        LastUpdatedDate = undefined;
        LastLoginDate = undefined;
        LastLogin = undefined;
        LastUpdated = undefined;
        IsLockedOut = false;
        IsActive = false;
        FullName = undefined;
        OldPassword = undefined;
        NewPassword = '';
        ConfirmPassword = '';
        Roles = [];
        hasBrandContext = false;
        hasCallCenterContext = false;
        hasStoreContext = false;
        hasSingleContext = false;
        IsUserEditable = undefined;
        initialiseUser = function (user) {
            return Object.assign(this, user);
        };

        initialiseUserContext(contextRoles) {
            this.hasBrandContext = this.getHasBrandContext(contextRoles);
            this.hasCallCenterContext = this.getHasCallCenterContext(contextRoles);
            this.hasStoreContext = this.getHasStoreContext(contextRoles);
            this.hasSingleContext = this.getHasSingleContext();
        };

        getRolesForPermission(permission) {
            return this.Roles.filter((role) => {
                return permission.Roles.find((permissionRole) => {
                    return permissionRole.Name === role.Name;
                });
            });
        };

        userHasRole(role) {
            return this.Roles.find((r) => r.RoleId === role);
        }

        getHasBrandContext(contextRoles) {
            return !!this.NonReportioRoles.find((role) => {
                return contextRoles.Brand.indexOf(role.RoleId) > -1;
            });
        };

        getHasCallCenterContext(contextRoles) {
            return !!this.NonReportioRoles.find((role) => {
                return contextRoles.CallCenter.indexOf(role.RoleId) > -1;
            });
        };

        getHasStoreContext(contextRoles) {
            return !!this.NonReportioRoles.find((role) => {
                return contextRoles.Store.indexOf(role.RoleId) > -1;
            });
        };

        get NonReportioRoles() {
            return (this.Roles || []).filter(
                r => r.RoleId !== REPORTIO_USER_ROLE &&
                    r.RoleId !== REPORTIO_ADMIN_ROLE
            );
        }

        getHasSingleContext() {
            var hasBrandContext = this.hasBrandContext;
            var hasCallCenterContext = this.hasCallCenterContext;
            var hasStoreContext = this.hasStoreContext;
            var onlyBrandContext = hasBrandContext && !hasCallCenterContext && !hasStoreContext;
            var onlyCallCenterContext = !hasBrandContext && hasCallCenterContext && !hasStoreContext;
            var onlyStoreContext = !hasBrandContext && !hasCallCenterContext && hasStoreContext;

            return onlyBrandContext || onlyCallCenterContext || onlyStoreContext;
        }
    }

    window.User = User;
    window.Dashboard.Models.User = User;
})();
